import { render, staticRenderFns } from "./ViewDefaultIndex.vue?vue&type=template&id=2f9927ef&scoped=true&"
import script from "./ViewDefaultIndex.vue?vue&type=script&lang=js&"
export * from "./ViewDefaultIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9927ef",
  null
  
)

export default component.exports